// extracted by mini-css-extract-plugin
module.exports = {"Row":"TableList_Row__3GD9d","Col":"TableList_Col__32_rw","Content":"TableList_Content__3ygXz","Sort":"TableList_Sort__1pUnD"};